import {  get, post } from '../utils/axios'

// export const getLeaveAPI = async (param) => {
//   return await get('leaves/details/types', param).catch((error) => {
//     throw new Error(error)
//   })
// }

export const getLeaveAPI = async (param) => {
  return await get('leaves/details/types', param)
}

export const getLeaveTypeAPI = async (param) => {
  return await get('leaves/types', param)
}

export const postLeaveTypeAPI = async (body) => {
  return await post('leaves/types', body)
}

export const putLeaveTypeAPI = async (body) => {
  return await post('leaves/types/update', body)
}

export const deleteLeaveTypeAPI = async (body) => {
  return await post('leaves/types/delete', body)
}

export const getLeaveTypeFullAPI = async (param) => {
  return await get('leaves/full/type', param)
}

export const getLeaveStatusFullAPI = async (body) => {
  return await get('leaves/full/status', body)
}
